import { makeAutoObservable } from 'mobx';
import { updatingStatusEnum } from '../../components/SaveStatusChips';
import { startCase } from 'lodash';

interface IUpdatingStatusText {
  [key: string]: string;
}
export interface IPatientProfileStore {
  updatingStatus: updatingStatusEnum;
  searchFilter: string;
  setSearchFilter(filter: string): void;
  updatingStatusText: IUpdatingStatusText;
  /**
  * @deprecated
  */
  setUpdatingStatus(
    status: updatingStatusEnum,
    name?: string,
    action?: string
  ): void;
  resetErrors(): void;
  isNewEpisodeCareDrawerOpen: boolean;
  setIsNewEpisodeCareDrawerOpen(open: boolean): void;
  isCreatingNewEpisode: boolean;
  setIsCreatingNewEpisode(isCreating: boolean): void;
}

export class PatientProfileStore implements IPatientProfileStore {
  updatingStatus = updatingStatusEnum.initial;
  searchFilter = '';
  updatingStatusText = {} as IUpdatingStatusText;
  isNewEpisodeCareDrawerOpen = false;
  isCreatingNewEpisode = false;

  constructor() {
    makeAutoObservable(this);
  }

  setUpdatingStatus(
    status: updatingStatusEnum,
    name?: string,
    action?: string
  ) {
    this.updatingStatus = status;
    if (status === updatingStatusEnum.failed && name) {
      this.updatingStatusText = {
        [name]: `Failed to ${action || 'save'} ${startCase(name)}`,
      };
    } else {
      this.updatingStatusText = {} as IUpdatingStatusText;
    }
  }

  setSearchFilter(filter: string) {
    this.searchFilter = filter;
  }

  resetErrors() {
    this.updatingStatusText = {} as IUpdatingStatusText;
  }

  setIsNewEpisodeCareDrawerOpen(open: boolean) {
    this.isNewEpisodeCareDrawerOpen = open;
  }

  setIsCreatingNewEpisode(isCreating: boolean) {
    this.isCreatingNewEpisode = isCreating;
  }
}
